import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  GithubAuthProvider,
  signInWithPopup,
  fetchSignInMethodsForEmail, // ✅ Add this
} from "firebase/auth";

export { fetchSignInMethodsForEmail }; // ✅ Export it

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

// ✅ Initialize Firebase app only once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

// ✅ Setup Auth
export const auth = getAuth(app);

// ✅ Google Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// ✅ GitHub Provider
export const githubProvider = new GithubAuthProvider();
githubProvider.addScope("user:email"); // request email explicitly

// ✅ Force account selection every time
githubProvider.setCustomParameters({
  allow_signup: "true", // optional: show signup option
  login: "select_account", // forces account chooser
});

// ------------------------
// Sign-in Functions
// ------------------------

// ✅ Google Sign-in
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    console.error("Google sign-in failed:", error);
    throw error;
  }
};

// ✅ GitHub Sign-in with safe email fallback
export const signInWithGithub = async () => {
  try {
    const result = await signInWithPopup(auth, githubProvider);
    const user = result.user;

    // ⚠️ Handle users with private emails
    const safeEmail = user.email || `${user.uid}@github-user.fake`;

    return { ...user, email: safeEmail };
  } catch (error: any) {
    // ⚠️ Handle existing account with different credential
    if (error.code === "auth/account-exists-with-different-credential") {
      console.error(
        "Account exists with different credentials. Suggest sign-in with original provider."
      );
    } else {
      console.error("GitHub sign-in failed:", error);
    }
    throw error;
  }
};

// ------------------------
// Logout Helpers
// ------------------------

// ✅ Google logout (clears session)
export const clearGoogleSession = () => {
  const iframe = document.createElement("iframe");
  iframe.src = "https://accounts.google.com/Logout";
  iframe.style.display = "none";
  document.body.appendChild(iframe);
  setTimeout(() => iframe.remove(), 2000);
};
